import request from './api'

export async function getUsersOfDogovor(dogovor) {
    try {
        const res = await request('/api/administration/users','POST',{dogovor: dogovor})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getUsersOfDogovorWithAuth(dogovor) {
    try {
        const res = await request('/api/administration/users-with-auth','POST',{dogovor: dogovor})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getAuthorities() {
    try {
        const res = await request('/api/administration/auths','POST',null)
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getAuditStat(username, d1, d2, options = {}) {
    try {
        const params = {
            username: username,
            d1: d1,
            d2: d2,
            limit: options.limit !== undefined ? options.limit : 50,
            offset: options.offset !== undefined ? options.offset : 0,
            sortBy: options.sortBy || 'dat',
            sortOrder: options.sortOrder || 'DESC',
            // ?? чтобы не терять 0 / false; пустая строка = «без фильтра»
            email: options.email ?? '',
            userId: options.userId ?? '',
            fio: options.fio ?? '',
            entryCount: options.entryCount ?? '',
            dogovor: options.dogovor ?? '',
        };
        const res = await request('/api/administration/get-audit','POST', params);
        return {
            isOk: true,
            data: Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []),
            pagination: res.pagination,
            sort: res.sort
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getAuditLog(username, d1, d2, options = {}) {
    try {
        const params = {
            username: username,
            d1: d1,
            d2: d2,
            limit: options.limit !== undefined ? options.limit : 50,
            offset: options.offset !== undefined ? options.offset : 0,
            sortBy: options.sortBy || 'dat',
            sortOrder: options.sortOrder || 'DESC',
            email: options.email || '',
            userId: options.userId || '',
            fio: options.fio || '',
            entryCount: options.entryCount || '',
            dogovor: options.dogovor || '',
            path: options.path || '',
            success: options.success || null,
        };
        const res = await request('/api/administration/get-audit-log','POST', params);
        return {
            isOk: true,
            data: Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []),
            pagination: res.pagination,
            sort: res.sort
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

/** Запрос аудита пользователей (построчный журнал: dat, fio, email, ndog, entity, success). */
export async function getUserAudit(body = {}) {
    try {
        const res = await request('/api/administration/user-audit', 'POST', body);
        return {
            isOk: true,
            data: Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []),
            pagination: res.pagination || {},
            sort: res.sort || {},
        };
    } catch (e) {
        return { isOk: false, message: e.message };
    }
}

export async function checkEmail(email, dogovor) {
    try {
        const res = await request('/api/administration/check-email','POST',{email: email, dogovor: dogovor})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function addToDog(idUser, dogovor, auths) {
    try {
        const res = await request('/api/administration/add-to-dog','PUT',{id: idUser, dogovor: dogovor, auths: auths})
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function registry(user, dogovor, auths) {
    try {
        const res = await request('/api/administration/registry','PUT',{user: user, dogovor: dogovor, auths: auths})
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function deleteUserDog(userDog) {
    try {
        const res = await request('/api/administration/remove','DELETE',{user_dog: userDog})
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function editRoles(userDog, roles) {
    try {
        const res = await request('/api/administration/edit-roles','PUT',{user_dog: userDog, roles: roles})
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function startImpersonate(userId, fingerprint) {
    try {
        const res = await request('/api/impersonate/start','POST',{userId, fingerprint})
        return {
            isOk: true,
            message: res.message,
            res: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getUsers() {
    try {
        const res = await request('/api/impersonate/users','POST',{})
        return {
            isOk: true,
            data: res.data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getActiveUsers() {
    try {
        const res = await request( '/api/impersonate/active-users', 'POST', {} )
        return {
            isOk: true, data: res.data
        }
    } catch (e) {
        return {
            isOk: false, message: e.message
        }
    }
}

export async function stopImpersonate(OriginalUserId, targetUserId, fingerprint) {
    try {
        const res = await request('/api/impersonate/stop','POST',{OriginalUserId, targetUserId, fingerprint})
        return {
            isOk: true,
            data: res.data,
            res:res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
